// eslint-disable-next-line import/no-named-default
import { default as uniqid } from 'uniqid'; // Webpack bundles this incorrectly unless this wacky import syntax is used
import { getLoaderConstructor } from '@nab/x-app-loaders';
import { clearStrategies } from '@nab/x-auth';
import { resetServicesRegistry, getUserForApp, resetUserRegistry, resetActionsRegistry, getShellActions, getUserForShell, getShellServices } from '@nab/x-registries';
import { registerInstance, reset as resetInstanceRegistry } from './registries/instanceRegistry';
import { createActionsForApp } from './actions/createActionsForApp';
let sessionId = uniqid();
let defaultAuthConfig = {};
export function setSessionId(id) {
    sessionId = id;
}
export function getSessionId() {
    return sessionId;
}
export function setAuthConfig(config) {
    defaultAuthConfig = config;
}
export function getAuthConfig() {
    return defaultAuthConfig;
}
export async function loadApp(...args) {
    if (!getShellActions()) {
        throw new Error(`x-runtime has not been initialised. Please use the initRuntime function before loading apps.`);
    }
    let appLoaderConfig = args.length === 1
        ? args[0]
        : {
            hostElement: args[1],
            appMetaData: args[0]
        };
    if (!appLoaderConfig.hostElement || !(appLoaderConfig.hostElement instanceof Element)) {
        throw new Error(`Invalid hostElement supplied for app ${appLoaderConfig.appMetaData.id}. hostElement must be a native DOM Element`);
    }
    appLoaderConfig = {
        ...appLoaderConfig,
        // Each app inherits the root session id and gets it's own unique instance ID
        appConfig: {
            sessionId,
            instanceId: uniqid(),
            ...(appLoaderConfig.appConfig || {})
        },
        // Each app inherits the default auth config for the shell with it's own overrides being applied over the top
        authConfig: {
            ...defaultAuthConfig,
            // The app's metadata is included in it's auth config so auth strategies can reference it (eg. token exchange strategy)
            appMetaData: appLoaderConfig.appMetaData,
            ...(appLoaderConfig.authConfig || {})
        }
    };
    const { tailoring } = getUserForShell();
    /**
     * @todo this isn't ideal as the logic is specific to XV1/XV2 apps... Consider a better approach
     * Note we can't resolve the versionAlias inside the AppLoader as it uses a shell flag rather then a mini-app flag
     */
    if (tailoring &&
        appLoaderConfig.appMetaData.assetManifestUrl &&
        appLoaderConfig.appMetaData.versionAlias !== 'NON-EXISTENT') {
        appLoaderConfig.appMetaData.versionAlias = tailoring.checkFlag(`miniapp-versionalias-${appLoaderConfig.appMetaData.id}`, 'NON-EXISTENT');
    }
    const user = getUserForApp({
        appMetaData: appLoaderConfig.appMetaData,
        appConfig: appLoaderConfig.appConfig
    });
    // Register the instance - This stores the config so we can refer to it when exposing public paths, routing events etc..
    registerInstance(appLoaderConfig.appConfig.instanceId, appLoaderConfig);
    // Get an app loader from the registry, this will return the most ideal loading strategy for this specific app
    const Loader = getLoaderConstructor(appLoaderConfig.appMetaData, appLoaderConfig.appConfig);
    const loader = new Loader({
        ...appLoaderConfig,
        // Create the actions set for this app instance
        actions: createActionsForApp(appLoaderConfig.appMetaData, appLoaderConfig.appConfig.instanceId),
        services: getShellServices(),
        user
    });
    // Start the app and return the loader instance so it can be stopped again or data updated if required
    await loader.load();
    return loader;
}
/**
 * Used only for testing. DO NOT EXPOSE!
 */
export function reset() {
    sessionId = uniqid();
    defaultAuthConfig = {};
    clearStrategies();
    resetInstanceRegistry();
    resetUserRegistry();
    resetActionsRegistry();
    resetServicesRegistry();
}
//# sourceMappingURL=core.js.map